var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',{staticClass:"dashboard",attrs:{"id":"microfrontend-application-container"}},[_c('SrAppContainer',{staticClass:"dashboard-container",attrs:{"hide-sidebar":""}},[_c('template',{slot:"content"},[_c('Dashboard')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }